// extracted by mini-css-extract-plugin
module.exports = {"token_icon":"DepositFunction_token_icon__h5FMr","shadowQr":"DepositFunction_shadowQr__cgEcv","iconBorderDark":"DepositFunction_iconBorderDark__AvZDU"};